import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../layout/ThemeContext';

import imgEnergyMgmt    from '../../../../public/ESGCaffe - Energy Management.png';
import imgCarbon        from '../../../../public/ESGCaffe - Carbon Accounting.png';

const images = [
  { id: 'energy',     src: imgEnergyMgmt, alt: 'Energy Management' },
  { id: 'carbon',     src: imgCarbon,     alt: 'Carbon Accounting' },
];

const ProductShowcase = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <section
      className={`py-10 md:py-12 transition-colors duration-500 ${
        isDark ? 'bg-[#0a1628]' : 'bg-slate-50'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-12">
          <div className={`text-[0.7rem] font-bold uppercase tracking-[0.15em] mb-3 ${isDark ? 'text-blue-400' : 'text-blue-600'}`}>
            Platform Overview
          </div>
          <h2
            className={`text-3xl md:text-4xl lg:text-[2.8rem] font-extrabold tracking-tight leading-tight ${
              isDark ? 'text-white' : 'text-slate-900'
            }`}
          >
            Your ESG Data,{' '}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-cyan-500 to-emerald-500">
              Visualized
            </span>
          </h2>
          <p className={`mt-3 text-sm md:text-base max-w-xl mx-auto leading-relaxed ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>
            Real-time dashboards powering enterprise ESG decisions.
          </p>
        </div>

        {/* Grid gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {images.map((img, i) => (
            <motion.div
              key={img.id}
              className={`rounded-xl border-2 overflow-hidden aspect-[4/3] ${
                isDark
                  ? 'border-slate-700 bg-slate-800 shadow-[0_4px_24px_rgba(0,0,0,0.5)]'
                  : 'border-slate-200 bg-white shadow-[0_4px_24px_rgba(0,0,0,0.12)]'
              }`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.45, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-contain object-top"
                loading="eager"
              />
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ProductShowcase;
